<template>
    <div :class="['yl-tabs-table', {'el_table_fixed_background': !tableForm.list || tableForm.list.length == 0}]">
        <transition-group name="el-alert-fade">
            <el-form :model="tableForm" :rules="tableForm" :ref="refName" label-width="100px" key="tableForm">
                <yl-table-bar :key="activeTab">
                    <el-table :data="tableForm.list"
                        :row-class-name="tableRowClassName"
                        @expand-change="changeExpand"
                        @row-click="getRowData"
                        @row-dblclick="dblclickRow"
                        @sort-change="sortChange"
                        @selection-change="getSelectData"
                        @select-all="getSelectALL"
                        row-key="id"
                        :key="'table_'+refName"
                        v-bind="tableAttributes"
                        :show-summary="updateSummaryStatus"
                        :summary-method="thisTable.summaryMethod || getSummaries"
                        :span-method="thisTable.spanMethod || (()=>{})"
                        :ref="'table_'+refName">
                        <template v-for="(item,index) in thisTable.header" >
                            <el-table-column 
                                v-if="item.type=='selection' && item.show==true" 
                                :type="item.type" 
                                :prop="item.prop" 
                                :label="item.label" 
                                :width="item.width" 
                                :align="item.align" 
                                :selectable="checkSelectAble" 
                                :reserve-selection="item.reserveSelection"
                                :fixed="item.attr && item.attr.fixed"
                                :key="index"
                            >
                            </el-table-column>
                            <el-table-column 
                                :type="item.type" 
                                :prop="item.prop" 
                                :label="item.label" 
                                :width="widthfun(item)" 
                                :min-width="item.type=='expand' ? null : item.width" 
                                :align="item.align"
                                :show-overflow-tooltip="item.tooltip"
                                :sortable="item.sortable" 
                                :key="index"
                                v-if="item.show && updateColumnStatus(item)" 
                                :fixed="item.attr && item.attr.fixed">
                                <!-- element表格头提示文字 -->
                                <template slot="header" v-if="item.headerTooltip">
                                    {{item.label}}
                                    <el-tooltip :content="item.headerTooltip" placement="top">
                                        <!-- <i class="el-icon-info textMinor"></i> -->
                                        <svg t="1639143822953" class="icon el_icon_tooltip" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5314" width="200" height="200">
                                            <path d="M512 960c-243.2 0-448-198.4-448-448 0-243.2 198.4-448 448-448 243.2 0 448 198.4 448 448s-204.8 448-448 448zM512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z" p-id="5315"></path>
                                            <path d="M460.8 307.2c0 25.6 19.2 51.2 51.2 51.2s51.2-19.2 51.2-51.2S537.6 256 512 256s-51.2 19.2-51.2 51.2zM512 768c-19.2 0-32-12.8-32-32V448c0-19.2 12.8-32 32-32s32 12.8 32 32v288c0 19.2-12.8 32-32 32z" p-id="5316"></path>
                                        </svg>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="scope">
                                    <span v-if="item.type=='expand'">
                                        <slot name="expand" :data="scope"></slot>
                                    </span>
                                    <div v-else-if="item.type=='index'">{{scope.$index+(currentPage - 1) * PageSize + 1}}</div>
                                    <span v-else-if="item.slot">
                                        <slot :name="item.slot" :data="scope"></slot>
                                    </span>
                                    <div v-else-if="item.attr && item.attr.type=='tag'">
                                        <el-form-item>
                                            <el-popover :placement="updatePopover(item,scope).placement" :title="updatePopover(item,scope).title" :width="updatePopover(item,scope).width" :trigger="updatePopover(item,scope).trigger" :disabled="updatePopover(item,scope).disabled" :content="updatePopover(item,scope).content">
                                                <div slot="reference">
                                                    <el-tag :type="item.attr.tagType" :size="item.attr.tagSize" :effect="item.attr.tagEffect">{{scope.row[item.prop]}}</el-tag>
                                                </div>
                                            </el-popover>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='tagCircle'">
                                        <el-button :type="item.attr.tagType" :size="item.attr.tagSize" circle></el-button>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='enum'">
                                        <el-form-item>
                                            <el-popover :placement="updatePopover(item,scope).placement" :title="updatePopover(item,scope).title" :width="updatePopover(item,scope).width" :trigger="updatePopover(item,scope).trigger" :disabled="updatePopover(item,scope).disabled" :content="updatePopover(item,scope).content">
                                                <div slot="reference">{{matchEnumField(item,scope)  || '--'}}</div>
                                                <!-- <div slot="reference" v-else>{{$store.getters[item.attr.gettersName](scope.row[item.prop],item.attr.name) || "--"}}</div> -->
                                            </el-popover>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='amount'">
                                        <el-form-item>
                                            <el-popover :placement="updatePopover(item,scope).placement" :title="updatePopover(item,scope).title" :width="updatePopover(item,scope).width" :trigger="updatePopover(item,scope).trigger" :disabled="updatePopover(item,scope).disabled" :content="updatePopover(item,scope).content">
                                                <div slot="reference">{{$function.AMOUNT.format(scope.row[item.prop],item.attr.toFixed)}}</div>
                                            </el-popover>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='date'">
                                        <el-form-item>
                                            <el-popover :placement="updatePopover(item,scope).placement" :title="updatePopover(item,scope).title" :width="updatePopover(item,scope).width" :trigger="updatePopover(item,scope).trigger" :disabled="updatePopover(item,scope).disabled" :content="updatePopover(item,scope).content">
                                                <div slot="reference">{{formatTime(scope.row[item.prop],item.attr.format) || "--"}}</div>
                                            </el-popover>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='handle'">
                                        <el-form-item>
                                            <div class="table_btn">
                                                <!-- 操作列按钮 -->
                                                <el-link 
                                                    class="mr10" 
                                                    :type="child.type || 'primary'" 
                                                    v-if="condition(child.condition,scope)" 
                                                    @click="child.callback(scope)" 
                                                    v-for="(child,childIndex) in handleList(item.attr.handle,scope)" 
                                                    :key="childIndex"
                                                >
                                                    {{child.prop?scope.row[child.prop]:child.text}}
                                                </el-link>
                                                <!-- 更多按钮 -->
                                                <el-dropdown v-if="!handleMoreHidden(item.attr.handle,scope)">
                                                    <el-button class="text" type="text" size="small">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <template v-for="(child,childIndex) in handleMoreList(item.attr.handle,scope)" >
                                                            <el-dropdown-item 
                                                                :key="childIndex"
                                                                v-if="condition(child.condition,scope)" 
                                                                @click.native="child.callback(scope)"
                                                            >
                                                                {{child.prop?scope.row[child.prop]:child.text}}
                                                            </el-dropdown-item>
                                                        </template>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                                <!-- 判断没有按钮的时候显示"--" -->
                                                <div v-if="handleHidden(item.attr.handle,scope)">--</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='input'">
                                        <el-form-item :prop="'list.'+scope.$index+'.'+item.prop" :rules="item.attr.rule">
                                            <el-input v-model="scope.row[item.prop]" :placeholder="item.attr.placeholder || '请输入'" size="small" class="w100"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='inputAmount'">
                                        <el-form-item :prop="'list.'+scope.$index+'.'+item.prop" :rules="item.attr.rule">
                                            <el-input v-model="scope.row[item.prop]" :placeholder="item.attr.placeholder || '请输入'" @focus="cancleAmountFormat(scope,item.prop)" @blur="createAmountFormat(scope,item.prop,item.attr.toFixed)" size="small" class="w100"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='inputDate'">
                                        <el-form-item>
                                            <el-date-picker v-model="scope.row[item.prop]" type="date" :placeholder="item.attr.placeholder || '请选择日期'" size="small" :value-format="item.attr.valueFormat || 'timestamp'" :format="item.attr.format || 'yyyy-MM-dd'" :picker-options="updatePickerOptions(item)"></el-date-picker>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='inputSwitch'">
                                        <el-form-item>
                                            <el-switch v-model="scope.row[item.prop]" :disabled="updateAttrDisabled(scope,item)"></el-switch>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='inputSelect'">
                                        <el-form-item>
                                            <el-select v-model="scope.row[item.prop]" placeholder="请选择" :disabled="updateAttrDisabled(scope,item)" @change="inputSelectFn(scope.row[item.prop],scope.$index)">
                                                <el-option :key="child[item.attr.value] || child.code" :label="child[item.attr.label] || child.name" :value="child[item.attr.value] || child.code" v-for="child in item.attr.data"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='checkbox'">
                                        <el-form-item>
                                            <el-checkbox v-model="scope.row[item.prop]" :disabled="updateAttrDisabled(scope,item)" @change="item.attr.callback && item.attr.callback(scope)">{{item.attr.prop?scope.row[item.attr.prop]:item.attr.text}}</el-checkbox>
                                        </el-form-item>
                                    </div>
                                    <div v-else-if="item.attr && item.attr.type=='checkboxGroup'">
                                        <el-form-item>
                                            <el-checkbox-group v-model="scope.row[item.prop]">
                                                <el-checkbox v-if="condition(child.condition,scope)" :key="child[item.attr.value] || child.code" :label="child[item.attr.value] || child.code" v-for="child in item.attr.data" :disabled="updateAttrDisabled(scope,item)">{{child[item.attr.label] || child.name}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </div>
                                    <span v-else>
                                        <template v-if="item.type != 'expand'">
                                            <span v-if="updatePopover(item,scope).disabled">
                                                {{scope.row[item.prop] || "--"}}
                                            </span>
                                            <el-form-item v-else>
                                                <el-popover :placement="updatePopover(item,scope).placement" :title="updatePopover(item,scope).title" :width="updatePopover(item,scope).width" :trigger="updatePopover(item,scope).trigger" :disabled="updatePopover(item,scope).disabled" :content="updatePopover(item,scope).content" :offset="updatePopover(item,scope).offset">
                                                    <div slot="reference" :style="{'overflow':'hidden','white-space':'nowrap','text-overflow':'ellipsis','width':updatePopover(item,scope).width}">{{scope.row[item.prop] || "--"}}</div>
                                                </el-popover>
                                            </el-form-item>
                                        </template>
                                    </span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </yl-table-bar>
            </el-form>
        </transition-group>
    </div>
</template>
<script type="text/javascript">
import ylTableBar from "./ylScrollBar.vue"
import column from "../js/tableColumnWidth.js"
export default {
    name: 'yl-lc-table',
    props:{
        data:{
            type:[Object,Array],
            default:()=>{
                return null;
            }
        },
        load:{
            type:Boolean,
            default:true
        },
    },
    computed:{
        //数据初始
        // updateData(){
        //     this.thisTable = this.data;
        //     return
        // },
        formatTime(){
            let _this=this;
            return (timestr,patter)=>{
                if(Number(timestr) && String(timestr).length==13){
                    return _this.$function.DATE.strToTime(Number(timestr),patter);
                }else{
                    return timestr;
                }
            }
        },
        // tableHeight(){
        //     if(this.thisTable && this.thisTable.attributes && this.thisTable.attributes.height=="auto"){
        //         return this.$store.state.main.tableHeight;
        //     }
        //     return (this.thisTable && this.thisTable.attributes && this.thisTable.attributes.height) || undefined;
        // },
        condition(){
            return (str,scope)=>{
                return str?eval(str):true;
            }
        },
        updateSummaryStatus(){
            return this.thisTable && this.thisTable.attributes && Boolean(this.thisTable.attributes.enableSummary);
        },
        updatePopover(){
            let _this=this;
            return (item,scope)=>{
                if(item.popover && item.popover.prop){
                    item.popover.content=scope.row[item.popover.prop].toString();
                }
                let obj = this.$function.BASE.repeatObject(item.popover);
                item.popover && Object.keys(item.popover).forEach(childItem=>{
                    if(["title","disabled"].indexOf(childItem)!=-1 && typeof item.popover[childItem] == "string" && item.popover[childItem].indexOf("scope")!=-1 ){
                        obj[childItem]=eval(item.popover[childItem]);
                    }
                });
                return Object.assign({},{
                    width:200,
                    title:"",
                    disabled:true,
                    trigger:"hover",
                    placement:"top-start",
                    content:"",
                    offset:0
                },obj);
            }
        },
        updateAttrDisabled(){
            let _this=this;
            return (scope,item)=>{
                if(typeof item.attr.disabled == "boolean"){
                    return item.attr.disabled;
                }else{
                    return item.attr.disabled?eval(item.attr.disabled):false 
                }
            }
        },
        updateColumnStatus(){
            return (item)=>{
                return item.condition?(item.type!='selection' && eval(item.condition)):item.type!='selection';
            }
        },
        searchButtonSpan(){
            if(this.thisTable.searchParmas.parmas.length%3==0){
                return 24;
            }
            if(this.thisTable.searchParmas.parmas.length%3==1){
                return 16;
            }
            if(this.thisTable.searchParmas.parmas.length%3==2){
                return 8;
            }
        },
    },
    watch:{
        "list":function(newList){
            if(newList instanceof Array){
                this.$set(this.tableForm,"list",newList);
            }
        },
        "data":{
            handler(tableList){
                this.thisTable = tableList;
            },
            immediate: true,
            deep:true
        }
    },
    components: {
        ylTableBar
    },
    data() {
        return {
            total:0,
            activeTab:"",
            prevTable:null,
            thisTable:{},
            refName:"",
            expands:[],
            tableForm:{
                list:[]
            },
            list:[],
            row:{},
            PageSize: 20,
            fullData:null,
            tableAttr:{
                type:"table",
                searchParmas:{
                    type:"text",
                    placeholder:"请输入",
                },
                attributes:{
                    "cardSearchStyle":"always",
                    "cardTableStyle":"always",
                    "highlight-current-row":true,
                    "height":null,
                    "stripe":false,
                    "summary":null
                }
            },
            currentPage:1,
            clearFormStyle:true,
            selectLength:0,
            selectedRow: [],
            copyTable: null,
            tableAttributes:{
                "cardSearchStyle":"always",
                "cardTableStyle":"always",
                "highlight-current-row":true,
                "height":null,
                "stripe":false,
                "summary":null
            },
            checkedData: []
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.thisTable = this.data;
            this.copyTable = this.$function.BASE.repeatObject(this.data.header[1]).label;
            this.tableAttributes = {
                ...this.tableAttributes,
                ...this.thisTable.attributes,
                ...this.$attrs
            }
            this.createDynamic();
            this.checkTableStyle();
        },
        // 20220317 操作列按钮是否都不显示
        handleHidden(list, scope){
            return list.every(data=>{
                return !this.condition(data.condition,scope)
            })
        },
        filterList(list,scope){
            list.forEach(item => {
                item.showAll = this.condition(item.condition,scope)
            })
            return list.filter(item => item.showAll)
        },
        handleList(list,scope){
            let newList = this.filterList(list,scope)
            if(newList.length > 2){
                return newList.slice(0, 2)
            }
            return newList
        },
        // 更多按钮是否都不显示
        handleMoreHidden(list, scope){
            let newList = this.filterList(list,scope)
            if(newList.length > 2){
                return false
            }
            return true
        },
        handleMoreList(list,scope){
            let newList = this.filterList(list,scope)
            if(newList.length > 2){
                return newList.slice(2)
            }
            return []
        },
        widthfun(item){
            if(item.type=='expand'){
                return column.name
            }
            return column[item.width]
        },
        //生成组件动态参数
        createDynamic(){
            this.refName="vueTable_"+parseInt(Math.random()*100000);
        },
        //展开或关闭行时
        changeExpand(row,expandedRows){
            let _this=this;
            this.$emit("changeExpand",{
                data:row,
                callback:function(){
                    if(row.id == _this.expands[0]) {
                        _this.expands = [];
                    } else {
                        //清空展开行
                        _this.expands = [];
                        _this.expands.push(row.id);
                    }    
                },
                expandedRows
            });
        },
        //返回当前选中行数据
        getRowData(row){
            this.row = row;
            this.$emit("changeRowData",row);
        },
        //双击某一行触发的事件
        dblclickRow(row){
            this.$emit("dblclickRow",row);
        },
        //当表格的排序条件发生变化的时候会触发该事件	
        sortChange(data){
            this.$emit("sortChange", data);
        },
        //检查表格样式，同时格式化初始化数据
        checkTableStyle(data){
            let _this=this;
            this.thisTable.header.map(item=>{
                if(item.headerTooltipSource){
                    if(window.LOWCODE.source){
                        item.headerTooltip = this.$lowcode.createMatchField(item.headerTooltipSource)
                    }else{
                        item.headerTooltip = this.$store.getters.getSourceVal(item.headerTooltipSource);
                    }
                }
                if(item.attr && item.attr.type && item.attr.type.indexOf("input")!=-1){
                    _this.clearFormStyle=false;
                    if(data){
                        data.map(item2=>{
                            if(item.attr.type=="inputAmount"){
                                item2[item.prop]=_this.$function.AMOUNT.format(item2[item.prop],item.attr.toFixed,false);
                            }
                        });
                    }
                }
            });
            //这里不可以判断为空，空也要更新列表
            if(data instanceof Array){this.$set(this.tableForm,"list",data);}
        },
        //合计
        getSummaries(param){
            let _this=this;
            const { columns, data } = param;
            const sums = [];
            let letterNum ,letterIndex;
            columns.forEach((column, index) => {
                let summaryData = undefined
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (typeof _this.thisTable.attributes.summary=="boolean" || (_this.thisTable.attributes.summary &&　JSON.stringify(_this.thisTable.attributes.summary).indexOf(column.property)!=-1))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let unit="";
                    if(Object.keys(_this.thisTable.attributes.summary[0]).length>0){
                        summaryData = _this.thisTable.attributes.summary.find(item=>item.field==column.property) || {}
                        unit=_this.thisTable.attributes.summary.find(item=>item.field==column.property).unit || "";
                        if(_this.thisTable.attributes.summary.find(item=>item.field==column.property).sum){
                            sums[index]=_this.$function.AMOUNT.format(_this.fullData[_this.thisTable.attributes.summary.find(item=>item.field==column.property).sum]) + unit;
                            return false;
                        }
                        // 合计是否需要格式化
                        if(_this.thisTable.attributes.summary.find(item=>item.field==column.property).unFormat){
                            if(_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize){
                                letterNum = this.$function.AMOUNT.fixedNumber(sums[index], summaryData.deciaml);
                                letterIndex =_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize;
                            }
                            sums[index]=this.$function.AMOUNT.fixedNumber(sums[index], summaryData.deciaml)+unit;
                        }else{
                            if(_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize){
                                letterNum = this.$function.AMOUNT.fixedNumber(sums[index], summaryData.deciaml);
                                letterIndex =_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize;
                            }
                            sums[index]=_this.$function.AMOUNT.format(this.$function.AMOUNT.fixedNumber(sums[index], summaryData.deciaml))+unit;
                        }
                    }

                } else if(!values.every(value => value) && (typeof _this.thisTable.attributes.summary=="boolean" || (_this.thisTable.attributes.summary &&　JSON.stringify(_this.thisTable.attributes.summary).indexOf(column.property)!=-1))){
                    if(_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize &&_this.thisTable.attributes.summary.find(item=>item.field==column.property).capitalize  ==  letterIndex){
                        sums[index] = _this.$function.AMOUNT.uppercase(letterNum)
                    }
                }else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        tableRowClassName({row, rowIndex}) {
            row.row_index = rowIndex;
        },
        //返回选中的多条数据
        getSelectData(rows){
            let isMultiple = this.thisTable.header.find(item => item.type === 'selection').isMultiple;
            if(!isMultiple){
                this.$nextTick(()=>{
                    this.checkedData = rows;
                    if (rows.length > 1) {
                        this.$refs['table_'+this.refName].clearSelection();
                        this.$refs['table_'+this.refName].toggleRowSelection(rows.pop());
                    }
                })
            }else{
                this.$nextTick(()=>{
                    // setNum 用于判断表头显不显示 已选多少个
                    if(rows.length > 0 &&!this.thisTable.header[1].headerTooltip&&!this.thisTable.header[1].setNum){
                        this.thisTable.header[1].label = `已选${rows.length}个`
                        // this.thisTable.header[1].headerTooltip = null
                    }else{
                        this.thisTable.header[1].label = this.copyTable
                    }
                })
            }
            this.selectLength = rows.length;
            this.selectedRow = rows;
            this.$emit("changeSelectRow",rows);
        },
        // 全选触发
        getSelectALL(selection){
            this.$nextTick(()=>{
                if(selection.length > 0 && !this.thisTable.header[1].headerTooltip&&!this.thisTable.header[1].setNum){
                    this.thisTable.header[1].label = `已选${selection.length}个`
                    // this.thisTable.header[1].headerTooltip = null
                }else{
                    this.thisTable.header[1].label = this.copyTable
                }
            })
            this.selectedRow = selection
            this.$emit("getSelectALL",selection);
        },
        clearSelectData(){
            this.$refs['table_'+this.refName].clearSelection();
        },
        setSelectData(rows){
            if (rows) {
                rows.forEach(row => {
                    this.$refs['table_'+this.refName].toggleRowSelection(row);        
                });
            } 
        },
        //新增
        add(data,callback){
            let options=Object.assign({},data);
            if(!this.tableForm.list){this.tableForm.list=[]}
            this.tableForm.list.push(options);
            this.$set(this.tableForm,"list",this.tableForm.list);
            typeof callback=="function" && callback();
        },
        //删除
        del(index,callback){
            if(!Number(index)){
                this.$message({
                    type: 'warning',
                    message: "缺少删除的索引值"
                });
                return false;
            }
            this.tableForm.list.splice(index,1);
            typeof callback=="function" && callback();
        },
        //返回表单校验状态 
        validate(){
            return new Promise((resolve, reject)=>{
                try {
                    this.$refs[this.refName].validate((valid) => {
                        resolve(valid);
                    });
                } catch (error) {
                    reject('reject',error); 
                }
            })
        },
        //返回表格数据
        getData(){
            return this.tableForm.list;
        },
        //金额格式化
        createAmountFormat(scope,field,reservedBit=2){
            scope.row[field]=this.$function.AMOUNT.format(scope.row[field],reservedBit,false);
        },
        //取消金额格式化
        cancleAmountFormat(scope,field){
            scope.row[field]=this.$function.AMOUNT.toNumber(scope.row[field]).toString();
        },
        //点击事件
        tabPaneClick(){
            if(this.activeTab==this.thisTable.attributes.name){
                return false;
            }
            this.PageSize=20;
            this.prevTable=this.$function.BASE.repeatObject(this.thisTable);
            this.$emit("changeTabsPane",this.activeTab);
            let data=this.data.find(item=>item.attributes.name==this.activeTab);
            this.$set(this,"thisTable",data);
            this.$set(this.tableForm,"list",[]);
            this.resetForm(this.prevTable,this.thisTable);
            this.$set(this.thisTable,"type",this.thisTable.type || "table");
        },
        checkSelectAble(row,index){
            let typeSelect=this.thisTable && this.thisTable.header && this.thisTable.header.find(item=>item.type=="selection");
            return (typeSelect && typeSelect.condition && typeSelect.condition.body)?eval(typeSelect.condition.body):true;
        },
        setActiveTab(activeTab){
            this.activeTab = activeTab;
            this.tabPaneClick()
        },
        listAppend(data){
            this.tableForm.list.concat(data);
        },
        inputSelectFn(item,index){
            this.$emit('inputSelectFn',item,index)
        },
        //清除排序状态为未排序
        clearSortable(){
            this.$refs['table_'+this.refName].clearSort()
        },
        matchEnumField(item,scope,callback){
            let res = "";
            let list = [];
            if(typeof item.attr.data == "string"){
                list = eval(list);
            }else{
                list = item.attr.data;
            }
            list.map(child=>{
                if(child[item.attr.value] == scope.row[item.prop]){
                    res = child[item.attr.label];
                }
            })
            return res;
            
        },
        updatePickerOptions(item){
            let _this = this;
            let region = {}
            let shortcut = item.attr.pickerOptionsShortcut;
            if(shortcut){
                if(shortcut == 4 && item.attr.pickerOptionsShortcutData){
                    region = _this.$function.PICKEROPTIONS.pickerOptionsAfterFn(item.attr.pickerOptionsShortcutData.split(","));
                }else if(shortcut == 5 && item.attr.pickerOptionsShortcutData){ 
                    region = _this.$function.PICKEROPTIONS.pickerOptionsFn(item.attr.pickerOptionsShortcutData);
                }else{
                    region = _this.$function.PICKEROPTIONS[shortcut]
                }
            }
            let pickerOptionsDisable = item.attr.pickerOptionsDisable;
            if(!pickerOptionsDisable){
                return region
            }else{
                return Object.assign(_this.$function.PICKEROPTIONS[item.attr.pickerOptionsDisable],region);
            }
        }
    }
};
</script>
<style lang="less" scope>
.el-form .el-table .el-form-item .el-form-item__content{margin-left: 0!important}
.yl-tabs-table{
    .el-button--small.is-circle{ display: block;}
    .el-tag.el-tag--small{display: block;}
}
.el-table__empty-block{
    width: 100% !important;
}
</style>